import React, { useRef, useState } from "react";

import CardBackground from "../../../../components/MainTemplate/CardBackground";
import PostComponent from "./PostComponent";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { useAtom } from "jotai";
import { gbState, postState } from "../../../../components/shared/GlobalState";
import { includes } from "lodash";
//Error Logging Service & Santize Input

const AdminTimelineSection = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  return (
    <>
      <CardBackground>
        <CreatePost
          onPostCreated={() => setRefreshTrigger((prev) => prev + 1)}
        />
      </CardBackground>
      <PostComponent refreshPosts={refreshTrigger} />
    </>
  );
};

const CreatePost = ({ onPostCreated }) => {
  let navigate = useNavigate();
  const [postData, setPostData] = useAtom(postState);
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedFileExtension, setFileExtension] = useState(null);
  const [selectedUploadFile, setSelectedUploadFile] = useState(null);

  const handleIconClick = (type) => {
    setFileExtension(type);
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Extract file extension from the file name
      const fileNameParts = file.name.split(".");
      const extension = fileNameParts[fileNameParts.length - 1];
      if (selectedFileExtension == "video") {
        let image_permission = ["mp4", "3gp"];
        if (!image_permission.includes(extension)) {
          setSelectedImage("");
          setSelectedUploadFile(null);
          toast.error("File should be [mp4,3gp] format only.");
          return;
        }
      } else {
        let image_permission = ["gif", "jpeg", "jpg", "png"];
        if (!image_permission.includes(extension)) {
          setSelectedImage("");
          setSelectedUploadFile(null);
          toast.error("Please select image format [gif,jpeg,jpg,png].");
          return;
        }
      }
      setSelectedImage(URL.createObjectURL(file));
      setSelectedUploadFile(file);
    }
  };
  const [formData, setFormData] = useState({
    _id: null,
    title: null,
    description: null,
    upload_file: null,
    file_type: null,
    church_id: user?.church_id,
    createdBy: user?._id,
  });
  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };
  const handleEvent = (e) => {
    e.preventDefault();
    let userToken = localStorage.getItem("token");

    // Simplified validation - only check title and description
    if (!formData.title?.trim()) {
      toast.error("Title can't be left blank.");
      return;
    }
    if (!formData.description?.trim()) {
      toast.error("Post content can't be left blank.");
      return;
    }

    formData.file_type = selectedFileExtension;

    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/post/add`,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userToken}`,
      },
      data: {
        title: formData.title,
        description: formData.description,
        file_type: selectedFileExtension,
        church_id: user?.church_id,
        createdBy: user?._id,
        image: selectedUploadFile,
      },
    };

    axios(config)
      .then(function (response) {
        toast.success("Post Created Successfully.");
        onPostCreated();
        // Reset form
        setFormData({
          _id: null,
          title: null,
          description: null,
          upload_file: null,
          file_type: null,
          church_id: user?.church_id,
          createdBy: user?._id,
        });
        setSelectedImage("");
        setSelectedUploadFile(null);
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "CreatePost", "/post/add");
      });
  };

  return (
    <div className="w-full p-3">
      <form
        onSubmit={(e) => handleEvent(e)}
        autoComplete="off"
        className="space-y-6"
      >
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-50">
              <i className="text-xl text-blue-600 mdi mdi-pencil" />
            </div>
            <h2 className="text-lg font-medium text-gray-800">Create Post</h2>
          </div>
          <button
            type="submit"
            className="flex items-center px-6 py-2 space-x-2 text-white transition-colors duration-200 bg-blue-600 rounded-md hover:bg-blue-700"
          >
            <i className="mdi mdi-send" />
            <span>Post</span>
          </button>
        </div>

        {/* Input Fields */}
        <div className="space-y-4">
          <input
            name="title"
            className="w-full px-4 py-3 placeholder-gray-400 transition-all duration-200 border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none"
            placeholder="Post Title"
            onChange={handleChange}
            value={formData.title ?? ""}
          />

          <textarea
            name="description"
            rows={4}
            className="w-full px-4 py-3 placeholder-gray-400 transition-all duration-200 border border-gray-200 rounded-lg resize-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:outline-none"
            placeholder="What's on your mind?"
            onChange={handleChange}
            value={formData?.description ?? ""}
          />
        </div>

        {/* Preview Section */}
        {selectedImage && (
          <div className="relative overflow-hidden border border-gray-200 rounded-lg bg-gray-50">
            {selectedFileExtension === "image" ? (
              <img
                src={selectedImage}
                alt="Preview"
                className="w-full object-cover max-h-[400px]"
              />
            ) : (
              <video src={selectedImage} controls className="w-full" />
            )}
            <button
              type="button"
              onClick={() => {
                setSelectedImage(null);
                setSelectedUploadFile(null);
              }}
              className="absolute p-1 transition-colors rounded-md top-2 right-2 bg-gray-800/50 hover:bg-gray-800"
            >
              <i className="text-white mdi mdi-close" />
            </button>
          </div>
        )}

        {/* Media Upload Buttons */}
        <div className="flex items-center pt-4 space-x-4 border-t border-gray-100">
          <button
            type="button"
            onClick={() => handleIconClick("image")}
            className="flex items-center px-4 py-2 space-x-2 text-gray-600 transition-colors rounded-lg hover:bg-gray-50"
          >
            <i className="text-xl text-green-500 mdi mdi-image" />
            <span>Photo</span>
          </button>

          <button
            type="button"
            onClick={() => handleIconClick("video")}
            className="flex items-center px-4 py-2 space-x-2 text-gray-600 transition-colors rounded-lg hover:bg-gray-50"
          >
            <i className="text-xl text-blue-500 mdi mdi-video" />
            <span>Video</span>
          </button>

          <input
            type="file"
            className="hidden"
            ref={fileInputRef}
            accept={
              selectedFileExtension === "image"
                ? "image/*"
                : "video/mp4,video/3gp"
            }
            onChange={handleFileChange}
          />
        </div>
      </form>
    </div>
  );
};

export default AdminTimelineSection;
